import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const ViewMonitoringHistoryContext = createContext(null);

type Props = {
  children: ReactElement;
};

const ViewMonitoringHistoryProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { id } = useParams();

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["monitoring_history"],
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`user_monitoring/${id}/history`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <ViewMonitoringHistoryContext.Provider value={contextValue}>
      {children}
    </ViewMonitoringHistoryContext.Provider>
  );
};

export default ViewMonitoringHistoryProvider;
